import React from "react";
import {
  Slide,
  ToastContainer,
  toast as _toast,
  ToastOptions,
} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";

import {
  CautionBanner,
  FailureBanner,
  InfoBanner,
  SuccessBanner,
  SpinnerBanner,
} from "../banners/Banner";

const Styled = styled.div`
  position: fixed;
  z-index: 99999;

  .Toastify__toast {
    background-color: white;
    border-radius: 0.4rem;
    color: #666;
    font-size: 1.25rem;
    font-family: inherit;
    min-height: 0;
    box-shadow: 0 0 1.5rem 0 rgba(0, 0, 0, 0.3);
    margin-bottom: 1.5rem;
    overflow: hidden;
    padding: 1.5rem;
  }
  .Toastify__toast:last-child {
    margin-bottom: 0;
  }
  .Toastify__toast.operation {
    background-color: #333;
    border: none;
    color: white;
    font-weight: 500;
  }

  .Toastify__toast-container {
    padding: 0;
  }

  .Toastify__toast-container--bottom-right {
    bottom: 1rem;
    right: 1rem;
  }

  .Toastify__toast-container {
    width: 350px;
  }
`;

// @todo: replace client usage with this
export const Toast = () => {
  return (
    <Styled>
      <ToastContainer
        position="top-center"
        hideProgressBar
        transition={Slide}
      />
    </Styled>
  );
};

// re-export to keep our API consistent
export const toast = {
  ..._toast,
  // override the default toast methods to use our banners
  success: (content: React.ReactNode, options?: ToastOptions) =>
    _toast.success(<SuccessBanner>{content}</SuccessBanner>, options),
  info: (content: React.ReactNode, options?: ToastOptions) =>
    _toast.info(<InfoBanner>{content}</InfoBanner>, options),
  error: (content: React.ReactNode, options?: ToastOptions) =>
    _toast.error(<FailureBanner>{content}</FailureBanner>, options),
  warning: (content: React.ReactNode, options?: ToastOptions) =>
    _toast.warn(<CautionBanner>{content}</CautionBanner>, options),
  spinner: (content: React.ReactNode, options?: ToastOptions) =>
    _toast.warn(<SpinnerBanner>{content}</SpinnerBanner>, options),
};
